module.exports = __webpack_public_path__ + "static/media/sliver-icon.b24c8672.png";